import SpeakButton from '@/components/feature/SpeakButton';
import AiRichContent from '@/components/feature/AiRichContent';
import InvoicePdfButton from './InvoicePdfButton';
import type { AssistantDocument } from '@/pages/dashboard/apps/mon-assistant/types';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  /** Langue de lecture (synthèse vocale). */
  lang?: string;
  /** Voix préférée du commerce (réglage Paramètres → Assistant). */
  voice?: string;
  /** Facture ou devis créé par l'assistant (bouton PDF direct). */
  invoice?: AssistantDocument;
}

export default function ChatMessage({ role, content, lang = 'fr', voice, invoice }: ChatMessageProps) {
  const isUser = role === 'user';

  return (
    <div className={`flex items-start gap-2.5 ${isUser ? 'flex-row-reverse' : ''}`}>
      <div
        className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${
          isUser ? 'bg-accent-100 text-accent-700' : 'bg-primary-100 text-primary-700'
        }`}
      >
        <i className={`ri-${isUser ? 'user' : 'robot-2'}-line text-sm`}></i>
      </div>
      <div
        className={`px-3.5 py-2.5 rounded-2xl text-sm leading-relaxed min-w-0 max-w-[85%] sm:max-w-[75%] [overflow-wrap:anywhere] ${
          isUser
            ? 'bg-accent-500 text-background-50 rounded-tr-md'
            : 'bg-background-100 text-foreground-800 rounded-tl-md'
        }`}
      >
        {isUser ? (
          <div className="whitespace-pre-wrap">{content}</div>
        ) : (
          <AiRichContent content={content} />
        )}
        {!isUser && invoice && (
          <div className="mt-2.5">
            <InvoicePdfButton
              invoiceId={invoice.id}
              number={invoice.number}
              docType={invoice.docType}
            />
          </div>
        )}
        {!isUser && (
          <div className="mt-2 pt-2 border-t border-background-200/60 flex items-center justify-end">
            <SpeakButton text={content} lang={lang} voice={voice} label="Écouter" />
          </div>
        )}
      </div>
    </div>
  );
}